import Dragdealer from 'dragdealer';
import { getNode } from './utils';
import './scss/_toggle.scss';

const template = `
    <div class="tsg-toggle">
      <div class="tsg-toggle__left"></div>
      <div class="tsg-toggle__bar">
        <div class="tsg-toggle__bar-left"></div>
        <div class="tsg-toggle__bar-right"></div>
        <div class="tsg-toggle__dot handle"></div>
      </div>
      <div class="tsg-toggle__right"></div>
    </div>
`;

class Toggle {
  constructor(
    nodeOrSelector, textLeft, valueLeft, textRight, valueRight, cbk,
    initialRight, simpleClickToggle,
  ) {
    this.container = getNode(nodeOrSelector);
    this.state = initialRight ? 1 : 0;
    this.isOnOff = !textRight;
    this.statePrev = this.state;
    this.texts = [textLeft, textRight];
    this.values = [valueLeft, valueRight];
    this.cbk = cbk;
    this.simpleClickToggle = simpleClickToggle;
    this.setupHTML();
    this.setupHandlers();
    this.initDrag();
  }

  setupHTML() {
    this.container.innerHTML = template;
    this.elems = {
      main: this.container.querySelector('.tsg-toggle'),
      left: this.container.querySelector('.tsg-toggle__left'),
      right: this.container.querySelector('.tsg-toggle__right'),
      bar: this.container.querySelector('.tsg-toggle__bar'),
      barLeft: this.container.querySelector('.tsg-toggle__bar-left'),
      barRight: this.container.querySelector('.tsg-toggle__bar-right'),
    };
    this.elems.left.innerHTML = this.texts[0];
    this.elems.right.innerHTML = this.texts[1];
    if (this.isOnOff) this.elems.main.classList.add('tsg-toggle--onoff');

    if (this.isOnOff) {
      if (this.state === 1) this.elems.left.classList.add('tsg-toggle--active');
    } else {
      if (this.state === 0) this.elems.left.classList.add('tsg-toggle--active');
      if (this.state === 1) this.elems.right.classList.add('tsg-toggle--active');
    }
  }

  setupHandlers() {
    if (this.simpleClickToggle) {
      this.elems.main.addEventListener('click', () => this.toggle());
    } else {
      this.elems.left.addEventListener('click', () => {
        if (this.isOnOff) {
          this.toggle();
        } else {
          this.goTo(0);
        }
      });
      this.elems.barLeft.addEventListener('click', () => { this.goTo(0); });
      this.elems.right.addEventListener('click', () => { this.goTo(1); });
      this.elems.barRight.addEventListener('click', () => { this.goTo(1); });
      this.elems.bar.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle();
      });
    }
  }

  initDrag() {
    const self = this;
    this.drag = new Dragdealer(this.elems.bar, {
      steps: 2,
      left: 0,
      right: 2,
      snap: false,
      loose: false,
      speed: 0.2,
      animationCallback() {
        const j = this.getStep()[0] - 1;
        if (j !== self.index) {
          self.set(j);
        }
      },
    });
    this.drag.setStep(this.state + 1, null, true);
    this.drag.reflow();
    setTimeout(() => {
      this.drag.reflow();
    }, 1000);
  }

  goTo(i) {
    this.state = i;
    this.drag.setStep(this.state + 1);
    this.set(i);
  }

  toggle() {
    if (this.state === 0) {
      this.goTo(1);
    } else {
      this.goTo(0);
    }
  }

  set(i) {
    if (i !== this.statePrev) {
      this.statePrev = i;
      this.cbk(this.values[i]);
      if (this.isOnOff) {
        if (i === 0) {
          this.elems.left.classList.remove('tsg-toggle--active');
        } else {
          this.elems.left.classList.add('tsg-toggle--active');
        }
      } else if (i === 0) {
        this.elems.left.classList.add('tsg-toggle--active');
        this.elems.right.classList.remove('tsg-toggle--active');
      } else {
        this.elems.left.classList.remove('tsg-toggle--active');
        this.elems.right.classList.add('tsg-toggle--active');
      }
    }
  }
}

export default Toggle;
